var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardBgSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 164,
    viewBox: "0 0 163 164",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dish-bg-part",
    d: "M4.17949 5.96364C4.17949 5.96364 43.1609 0 81.5 0C119.839 0 158.821 5.96364 158.821 5.96364C158.821 5.96364 163 48.9338 163 82C163 115.066 158.821 158.036 158.821 158.036C158.821 158.036 119.839 164 81.5 164C43.1609 164 4.17949 158.036 4.17949 158.036C4.17949 158.036 0 115.066 0 82C0 48.9338 4.17949 5.96364 4.17949 5.96364Z",
    fill: "#ECEDED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBgSmall);
export default __webpack_public_path__ + "static/media/card-bg-small.1fdedcc44d4f870cd0dd49841dbc5c35.svg";
export { ForwardRef as ReactComponent };